import { AxiosError } from 'axios';
import { QueryConfig, QueryResult, useQuery } from 'react-query';

import { __DEV__ } from '~src/config';
import { loadSecurityGroups } from '~src/services/api';
import { DbSecurityGroup } from '~src/types/db';
import { useProjectId } from '~src/hooks/useProjectId';

export const useSecurityGroups = (
  queryConfig: QueryConfig<DbSecurityGroup[], AxiosError> & {
    enabled?: boolean;
  } = {}
): QueryResult<DbSecurityGroup[], AxiosError> => {
  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const foldersQuery = useQuery<DbSecurityGroup[], AxiosError>(
    ['securityGroups', { projectId: String(projectId) }],
    loadSecurityGroups,
    {
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return foldersQuery;
};

interface UseProjectSecurityGroupsProps {
  projectId: string;
}

export const useProjectSecurityGroups = (
  { projectId }: UseProjectSecurityGroupsProps,
  queryConfig: QueryConfig<DbSecurityGroup[], AxiosError> & {
    enabled?: boolean;
  } = {}
): QueryResult<DbSecurityGroup[], AxiosError> => {
  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const foldersQuery = useQuery<DbSecurityGroup[], AxiosError>(
    ['projectSecurityGroups', { projectId: String(projectId) }],
    loadSecurityGroups,
    {
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );
  return foldersQuery;
};
